import React from "react";
import MUIDataTable from "mui-datatables";

export default function DataTableBase(props) {
  const {
    columns,
    data,
    title,
    orderby,
    orderdirection,
    selectableRows,
    rowsSelected,
    onRowsSelect,
    customToolbarSelect,
    customToolbar,
  } = props;

  return (
    <MUIDataTable
      title={title}
      data={data}
      columns={columns}
      options={{
        selectableRows: selectableRows || "none",
        responsive: "vertical",
        download: true,
        print: false,
        viewColumns: true,
        filter: true,
        search: true,
        sortOrder: {
          name: orderby ? orderby : "time_created",
          direction: orderdirection || "desc",
        },
        ...(rowsSelected ? { rowsSelected } : {}),
        ...(onRowsSelect ? { onRowsSelect } : {}),
        ...(customToolbarSelect ? { customToolbarSelect } : {}),
        ...(customToolbar ? { customToolbar } : {}),
      }}
    />
  );
}
